import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo, fileUrl } from "../lib/seo";
import { Store, ShoppingBag } from "lucide-react";
import { Stars } from "../components/ProductReviews";

export const PRODUCT_CATS = [
  { k: "rudraksha", l: "Rudraksha & Malas" }, { k: "ghee", l: "Ghee & Diyas" }, { k: "incense", l: "Incense & Dhoop" },
  { k: "books", l: "Books & Scripture" }, { k: "idols", l: "Idols & Yantras" }, { k: "other", l: "Other Puja Items" },
];

export default function Shop() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("");
  useSeo("Sacred Shop");
  useEffect(() => { api.get(`/shop/products${cat ? `?category=${cat}` : ""}`).then((r) => setItems(r.data.items)); }, [cat]);

  return (
    <div data-testid="shop-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-2xl">
          <div className="overline">॥ पूजा सामग्री ॥</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#4A0E17] mt-2 leading-tight">Sacred Shop</h1>
          <p className="text-[#63534E] mt-5 text-base md:text-lg">Authentic puja items sold directly by verified suppliers. Each purchase supports the artisan and Pancham Dham.</p>
        </div>
        <Link to="/become-supplier" data-testid="shop-sell-cta" className="btn-ghost-gold"><Store className="w-4 h-4" /> Sell on Pancham Dham</Link>
      </div>
      <div className="mt-10 flex flex-wrap gap-2">
        {[{ k: "", l: "All" }, ...PRODUCT_CATS].map((c) => (
          <button key={c.k || "all"} data-testid={`shop-cat-${c.k || "all"}`} onClick={() => setCat(c.k)}
            className={`px-4 h-9 rounded-full text-sm border transition-sacred ${cat === c.k ? "bg-[#4A0E17] text-[#F3E5AB] border-[#4A0E17]" : "bg-[#FFFDF9] text-[#4A0E17] border-[#D4AF37]/40"}`}>{c.l}</button>
        ))}
      </div>
      {items.length === 0 ? (
        <div data-testid="shop-empty" className="mt-12 bg-[#FFFDF9] sacred-border rounded-3xl p-16 text-center">
          <ShoppingBag className="w-12 h-12 text-[#D4AF37] mx-auto" />
          <h3 className="font-serif text-2xl text-[#4A0E17] mt-4">The bazaar is opening soon</h3>
          <p className="text-[#63534E] mt-2">Our first suppliers are adding their products now.</p>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {items.map((p) => (
            <Link key={p.id} to={`/shop/${p.id}`} data-testid={`product-card-${p.id}`} className="group bg-[#FFFDF9] sacred-border rounded-2xl overflow-hidden gold-glow transition-sacred">
              <div className="aspect-square bg-[#F3E5AB]/40 overflow-hidden">
                {p.image_urls?.[0] ? <img src={fileUrl(p.image_urls[0])} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  : <div className="w-full h-full flex items-center justify-center font-devanagari text-6xl text-[#D4AF37]">ॐ</div>}
              </div>
              <div className="p-4">
                <div className="text-xs text-[#8C6D3B]">{p.supplier_name}</div>
                <div className="font-serif text-lg text-[#4A0E17] leading-tight line-clamp-2">{p.title}</div>
                {p.review_count > 0 && <div className="flex items-center gap-1 mt-1 text-xs text-[#63534E]"><Stars value={p.rating_avg} size="w-3 h-3" /> ({p.review_count})</div>}
                <div className="flex items-center justify-between mt-2">
                  <span className="font-mono text-lg font-semibold text-[#E65100]">${p.price_usd.toFixed(2)}</span>
                  <span className="text-xs text-[#63534E]">{p.stock > 0 ? `${p.stock} in stock` : "Sold out"}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
